import { useState } from 'react';
import { Link } from 'react-router';
import { mealsLabel } from '../lib/format';
import { Icon } from '../components/ui';
import { Av, Badge, Card, Chip, Chips, Empty, Group, Row, Screen, Top } from '../components/p';
import { useSubscribers } from '../lib/queries';

/** 🔍 Find anyone, as drawn (P04): by name, phone or flat. Orders and Menus join the results as they arrive. */
export function Search() {
  const [q, setQ] = useState('');
  const term = q.trim();
  const list = useSubscribers(term, 'all');
  const items = term ? list.data?.items ?? [] : [];
  return (
    <Screen>
      <Top>
        <label className="p-search">
          <Icon name="search" size={18} sw={2} />
          <input aria-label="Search" autoFocus value={q} placeholder="Name, phone or flat" onChange={(e) => setQ(e.target.value)} />
        </label>
        <Link className="p-back" to="/">Cancel</Link>
      </Top>
      {!term && (
        <Group label="Try">
          <Chips>{['A phone number', 'Villa or flat', 'A name'].map((t) => <Chip key={t}>{t}</Chip>)}</Chips>
        </Group>
      )}
      {term && !list.isPending && items.length === 0 && <Card><Empty title="No one found">Try a phone number, or part of a name or flat.</Empty></Card>}
      {items.length > 0 && (
        <Group label="Customers">
          <Card>
            {items.map((i) => (
              <Row key={i.subscriberId} to={`/s/${i.subscriberId}`} left={<Av name={i.name} />} t={i.name}
                s={[i.slot ? `${mealsLabel(i.slot)} plan` : null, i.area].filter(Boolean).join(' · ')}
                right={i.state === 'active' ? <Badge tone="g">Active</Badge> : i.state === 'upcoming' ? <Badge>Starts soon</Badge> : i.state === 'none' ? undefined : <Badge>{i.state === 'closed' ? 'Closed' : 'Ended'}</Badge>} />
            ))}
          </Card>
        </Group>
      )}
    </Screen>
  );
}
